import { ICustomCta } from '@campaign-form/campaign-form.interface';
import { EExecutionType } from '../deliverable-flow-dialog/execution-step/execution-list/execution/execution.interface';

export type TCtaSummaryDeliverable = ICustomCta & { id?: string | null; name?: string | null; type?: string | null };
export type TCtaSummaryKpi = ICustomCta & { expectedValue?: number | null; id?: string | null; kpi?: string | null };
export type TCtaSummaryExecution = ICustomCta & {
  duration?: number | null;
  executionCountTarget?: number | null;
  executionDate?: Date | null;
  executionTime?: Date | null;
  executionType?: EExecutionType | null;
  expectedKpis?: TCtaSummaryKpi[];
  id?: string | null;
};
export type TCtaSummaryExecutionRow = TCtaSummaryExecution & { durationLabel: string | null; label: string };

export const EXECUTION_TYPE_ORDER: Record<EExecutionType, number> = {
  [EExecutionType.unique]: 0,
  [EExecutionType.undesignated]: 1,
  [EExecutionType.always]: 2,
};
